import { Potencia, InputPotencia } from './../../common/types/Potencia'
import axios from '@/plugins/axios'
import GenericService from '@/shareds/GenericService'
import { Loja } from 'common/types/Loja'
import IrmaoService from './IrmaoService'

export const PATH_POTENCIA = '/potencias'

class PotenciaService extends GenericService<Potencia, InputPotencia> {
	constructor() {
		super(PATH_POTENCIA)
	}

	async getLojas(id: string) {
		try {
			const result = await axios.get<Loja[]>(`${this.route}/${id}/lojas`)
			return result.data
		} catch (error) {
			throw error
		}
	}

	async getAdministradores(id: string) {
		try {
			return IrmaoService.find({
				potencia: id,
				cargoDeAdminDaPotencia: {
					$nin: [ null, '' ],
				},
			})
		} catch (error) {
			throw error
		}
	}
}

export default new PotenciaService()
